module.exports = __webpack_public_path__ + "static/img/weiyuanhui.62c0d940.png";